import { render, staticRenderFns } from "./RegraCoalesce.vue?vue&type=template&id=772561bb&scoped=true"
import script from "./RegraCoalesce.vue?vue&type=script&lang=js"
export * from "./RegraCoalesce.vue?vue&type=script&lang=js"
import style0 from "./RegraCoalesce.vue?vue&type=style&index=0&id=772561bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772561bb",
  null
  
)

export default component.exports